import { useEffect, useState } from "react";
import { X, Check, Loader2, History } from "lucide-react";
import { api, errorMessage } from "../api";
import { ModTable } from "./KotHistory";

export const canReduceKot = (role) => ["owner", "admin", "manager", "cashier"].includes(role || "owner");

export function KotModifyModal({ tab, idx, role, onClose, onDone }) {
  const it = tab.items[idx];
  const privileged = canReduceKot(role);
  const [qty, setQty] = useState(it.qty);
  const [notes, setNotes] = useState(it.notes || "");
  const [cancel, setCancel] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const needsReason = cancel || Number(qty) < it.qty;
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      const { data } = await api.post(`/tabs/${tab.id}/items/${idx}/modify`, { qty: Number(qty), notes, cancel, reason });
      onDone(data);
    } catch (e2) { setErr(errorMessage(e2)); } finally { setBusy(false); }
  };
  return (
    <div className="modal-backdrop"><div className="modal" data-testid="kot-modify-modal">
      <div className="modal-head"><div><span className="overline">MODIFY SENT KOT · {it.kot_no}</span><h2>{it.name}</h2></div><button className="icon-button" onClick={onClose} data-testid="kot-modify-close"><X size={18} /></button></div>
      <form onSubmit={submit}>
        <div className="form-grid">
          <label>Quantity (now {it.qty})<input type="number" min={privileged ? 1 : it.qty} value={qty} disabled={cancel} onChange={(e) => setQty(e.target.value)} data-testid="kot-modify-qty" /></label>
          <label>Kitchen note<input value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="e.g. less spicy" data-testid="kot-modify-notes" /></label>
        </div>
        {privileged ? (
          <label style={{ display: "flex", gap: 8, alignItems: "center" }}><input type="checkbox" style={{ width: "auto", margin: 0 }} checked={cancel} onChange={(e) => setCancel(e.target.checked)} data-testid="kot-modify-cancel" /> Cancel this item</label>
        ) : <p className="form-hint" data-testid="kot-modify-waiter-hint">Waiters can add notes or increase quantity. Ask a manager or cashier to reduce or cancel.</p>}
        {(needsReason || privileged) && (
          <label>Reason {needsReason ? "(required)" : "(optional)"}<input value={reason} required={needsReason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Guest changed order" data-testid="kot-modify-reason" /></label>
        )}
        {err && <div className="auth-alert error" data-testid="kot-modify-error">{err}</div>}
        <button className="primary-button full" disabled={busy} data-testid="kot-modify-submit">{busy ? <Loader2 className="spin" size={14} /> : <Check size={14} />} Send modification to kitchen</button>
      </form>
    </div></div>
  );
}

export function TabHistory({ tab, branch }) {
  const [rows, setRows] = useState([]);
  const n = (tab.modifications || []).length;
  useEffect(() => { if (!n) { setRows([]); return; } api.get(`/kot-history?branch=${branch}&tab_id=${tab.id}`).then(({ data }) => setRows(data)).catch(() => {}); }, [tab.id, branch, n]);
  if (!n) return null;
  return (
    <div className="panel tab-history" data-testid="tab-history">
      <div className="panel-head"><div><span className="overline"><History size={11} /> MODIFICATION HISTORY</span><h2>{n} change{n > 1 ? "s" : ""} on this tab</h2></div></div>
      <ModTable rows={rows} testid="tab-history-table" />
    </div>
  );
}
